import type { InstallmentCalulatorLayout } from '../../types';
import { Collapsed } from './Collapsed';
import { CompactAndColumn } from './CompactAndColumn';

export interface InstallmentCalculatorSuspenseFallbackProps {
  calculatorLayout: InstallmentCalulatorLayout;
}

export const InstallmentCalculatorSuspenseFallback = ({
  calculatorLayout,
}: InstallmentCalculatorSuspenseFallbackProps) =>
  calculatorLayout === 'Collapsible' ? <Collapsed /> : <CompactAndColumn />;
